import { Injectable, NgZone } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { take } from 'rxjs';
import { ConfigService } from '../config-service/config-service.service';
import { KeycloakWrapperService } from '../keycloak-wrapper-service/keycloak-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class IdleTimeoutService {
  private timeoutId: any;
  private idleTime = 300 * 1000; // 5 minute in milliseconds
  private lastActivityTime: number = Date.now();

  constructor(
    private ngZone: NgZone,
    private keycloakService: KeycloakWrapperService,
    private configService: ConfigService,
  ) {}

  public setIdleTimeout() {
    let isUserLoggedInAndValid = this.keycloakService.isLoggedIn();
    if (!isUserLoggedInAndValid) {
      const token = sessionStorage.getItem('token');
      if (!token) {
        return;
      }
      const isTokenValid = (jwtDecode(token) as { exp: number })?.exp > Date.now() / 1000;
      isUserLoggedInAndValid = !!(token && isTokenValid);
    }
    if (isUserLoggedInAndValid) {
      this.configService
        .getConfig()
        .pipe(take(1))
        .subscribe((config) => {
          const refreshToken = this.keycloakService.getKeycloakInstance().refreshTokenParsed;

          const refreshTokenValidityInSeconds = (refreshToken?.exp ?? 0) - (refreshToken?.iat ?? 0);
          if (refreshTokenValidityInSeconds < 0 || refreshTokenValidityInSeconds === 0) {
            this.idleTime = (config.idleTimeout ?? 300) * 1000;
          } else {
            console.log(`refreshTokenValidityInSeconds: ${refreshTokenValidityInSeconds}`);
            this.idleTime = (config.idleTimeout ?? refreshTokenValidityInSeconds) * 1000;
            this.idleTime = Math.min(this.idleTime, refreshTokenValidityInSeconds * 1000);
          }

          this.setupEvents();
          this.setupVisibilityListener();
          this.resetTimer();
        });
    }
  }

  private setupEvents() {
    const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keypress', 'scroll'];
    events.forEach((event) => {
      window.addEventListener(event, (e: Event) => {
        if (e.isTrusted) {
          this.resetTimer();
        }
      });
    });
  }

  private setupVisibilityListener() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        // Page became visible - check if idle time exceeded while backgrounded
        const elapsedTime = Date.now() - this.lastActivityTime;
        if (elapsedTime >= this.idleTime) {
          console.log('Logging out due to idle timeout on visibilitychange');
          this.logout();
        } else {
          // Resume timer with remaining time
          this.resetTimer();
        }
      }
    });
  }

  private resetTimer() {
    this.lastActivityTime = Date.now();

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.logout(), this.idleTime);
    });
  }

  private logout() {
    console.log('Logging out due to idle timeout on timeout timer expiry');
    this.ngZone.run(() => {
      this.keycloakService.idleTimeLogout();
    });
  }
}
